import React from 'react';
import PropTypes from 'prop-types';

import { VenueSearch } from 'js/components/VenueSearch';

const QuestionSearch = ({ treatment, i18n, popularLocations }) => {
  if (!treatment) {
    return null;
  }
  const browseUriValues = {
    offerResultType: 'local',
    treatments: treatment.normalisedName,
  };

  return (
    <VenueSearch
      title={i18n('venue-search.title').replace(
        '{entity-type}',
        treatment.name
      )}
      typeAhead={{
        treatmentIds: treatment.id,
      }}
      browseUriValues={browseUriValues}
      popularLocations={popularLocations}
    />
  );
};

QuestionSearch.propTypes = {
  treatment: PropTypes.object,
  i18n: PropTypes.func,
  popularLocations: PropTypes.array,
};

export default QuestionSearch;
